<form class="member-detail-form" [formGroup]="memberDetailForm" (ngSubmit)="onSubmit()">
  <div class="member-detail-page">
    <header class="member-detail-hero">
      <div class="member-detail-hero__inner">
        <div class="member-detail-hero__brand">
          <a [routerLink]="'/dashboard/members'" class="member-detail-back">
            <i class="pi pi-arrow-left"></i>
            <span>{{ 'MEMBER_DETAIL.BACK' | translate }}</span>
          </a>
          <div class="member-detail-hero__text">
            <span class="member-detail-hero__eyebrow">
              {{ (creando ? 'MEMBER_DETAIL.PAGE_SUBTITLE_NEW' : 'MEMBER_DETAIL.PAGE_SUBTITLE') | translate }}
            </span>
            <h1 class="member-detail-hero__title">
              @if (creando) {
              {{ 'MEMBER_LIST.ADD_MEMBER' | translate }}
              } @else {
              {{ memberDetailForm.get('nombres')?.value || miembro?.nombres }}
              {{ memberDetailForm.get('apellidos')?.value || miembro?.apellidos }}
              }
            </h1>
          </div>
        </div>
        <div class="member-detail-hero__meta">
          @if (memberDetailForm.get('fechaNacimiento')?.value && edadMiembro) {
          <span class="member-detail-chip">
            <i class="pi pi-calendar"></i>
            {{ 'MEMBER_DETAIL.AGE_LABEL' | translate }}{{ edadMiembro }}
          </span>
          }
          @if (canViewLogs && !creando) {
          <p-button type="button" icon="pi pi-history" [label]="'MEMBER_DETAIL.HISTORY_BUTTON' | translate"
            severity="secondary" [outlined]="true" styleClass="member-detail-hero__btn"
            [pTooltip]="'MEMBER_DETAIL.TOOLTIP_HISTORY' | translate" tooltipPosition="bottom"
            (onClick)="openHistorial()" />
          }
          <p-button type="submit" data-tour="member-save"
            [label]="creando ? ('MEMBER_DETAIL.BTN_SAVE' | translate) : ('MEMBER_DETAIL.BTN_UPDATE' | translate)"
            icon="pi pi-check" iconPos="right" severity="success" [styleClass]="saveButtonStyleClass" />
        </div>
      </div>
    </header>

    <div class="member-detail-layout">
      <aside class="member-detail-nav">
        <article class="member-detail-panel member-detail-panel--nav">
          <header class="member-detail-panel__head">
            <div class="member-detail-panel__icon member-detail-panel__icon--brand">
              <i class="pi pi-user"></i>
            </div>
            <div class="member-detail-panel__titles">
              <h2 class="member-detail-panel__title">{{ 'MEMBER_DETAIL.NAV_SECTIONS' | translate }}</h2>
            </div>
          </header>
          <div class="member-detail-panel__body member-detail-panel__body--nav">
          <div class="member-detail-nav__list" role="navigation" aria-label="Secciones del miembro" data-tour="member-sections">
            <button type="button" class="member-detail-nav__item"
              [class.member-detail-nav__item--active]="activeView === 'personal'"
              (click)="setActiveView('personal')">
              <span class="member-detail-nav__icon"><i class="pi pi-id-card"></i></span>
              <span>{{ 'MEMBER_DETAIL.MENU_PERSONAL' | translate }}</span>
            </button>
            <button type="button" class="member-detail-nav__item"
              [class.member-detail-nav__item--active]="activeView === 'espiritual'"
              (click)="setActiveView('espiritual')">
              <span class="member-detail-nav__icon"><i class="pi pi-book"></i></span>
              <span>{{ 'MEMBER_DETAIL.MENU_SPIRITUAL' | translate }}</span>
            </button>
            <button type="button" class="member-detail-nav__item"
              [class.member-detail-nav__item--active]="activeView === 'salud'"
              (click)="setActiveView('salud')">
              <span class="member-detail-nav__icon"><i class="pi pi-heart"></i></span>
              <span>{{ 'MEMBER_DETAIL.MENU_HEALTH' | translate }}</span>
            </button>
            <button type="button" class="member-detail-nav__item"
              [class.member-detail-nav__item--active]="activeView === 'pastorales'"
              (click)="setActiveView('pastorales')">
              <span class="member-detail-nav__icon"><i class="pi pi-comments"></i></span>
              <span>{{ 'MEMBER_DETAIL.MENU_PASTORAL' | translate }}</span>
            </button>
            <button type="button" class="member-detail-nav__item"
              [class.member-detail-nav__item--active]="activeView === 'diezmos'"
              (click)="setActiveView('diezmos')">
              <span class="member-detail-nav__icon"><i class="pi pi-wallet"></i></span>
              <span>{{ 'MEMBER_DETAIL.MENU_TITHES' | translate }}</span>
            </button>
          </div>
          </div>
        </article>
      </aside>

      <div class="member-detail-main">
        <div class="member-detail-panel member-detail-panel--content">
          <div class="member-detail-panel__body">
            @switch (activeView) {
              @case ('personal') {
              <div class="row mb-3">
                <div class="col-md-12 col-lg-4 col-xl-4 mb-3">
                  <div class="detail-section detail-section--profile">
                    <div class="row">
                      <div class="col-md-6 text-start">
                        <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.PROFILE_PHOTO' | translate }}</h3>
                      </div>
                      <div class="col-md-6 text-end">
                        <p-button icon="pi pi-upload" size="small" [pTooltip]="'MEMBER_DETAIL.TOOLTIP_UPLOAD_PHOTO' | translate" tooltipPosition="right"
                          [rounded]="true" severity="success" (click)="fotoInput.click()" />
                      </div>
                    </div>
                    <div class="photo mt-1">
                      <div class="relative w-fit mx-auto mb-2">
                        <p-avatar shape="circle" class="shadow" style="width: 120px; height: 120px; font-size: 2rem"
                          [image]="previewFotoBase64 || memberDetailForm.get('photoUrl')?.value">
                        </p-avatar>
                        <input type="file" accept="image/*" #fotoInput style="display: none"
                          (change)="onFotoSeleccionada($event)" />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12 text-center">
                        @if (memberDetailForm.get('fechaNacimiento')?.value) {
                        <h4 class="text-success"><strong>{{ 'MEMBER_DETAIL.AGE_LABEL' | translate }}</strong>{{edadMiembro}}</h4>
                        }
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mb-3" data-tour="member-names">
                        <p-floatLabel variant="on" [ngClass]="{'field-invalid': isInvalidRequired('nombres')}">
                          <input pInputText id="nombres" formControlName="nombres" class="form-control" />
                          <label for="nombres">{{ 'MEMBER_DETAIL.FIELD_NAMES' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-12 mb-3">
                        <p-floatLabel variant="on">
                          <input pInputText id="apellidos" formControlName="apellidos" class="form-control" />
                          <label for="apellidos">{{ 'MEMBER_DETAIL.FIELD_SURNAMES' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-12 mb-3">
                        <p-floatLabel variant="on">
                          <input pInputText id="email" class="form-control" formControlName="email" />
                          <label for="email">{{ 'MEMBER_DETAIL.FIELD_EMAIL' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-12">
                        <p-floatLabel variant="on">
                          <input pInputText id="telefono" class="form-control" formControlName="telefono" />
                          <label for="telefono">{{ 'MEMBER_DETAIL.FIELD_PHONE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-8 col-xl-8">
                  <div class="detail-section">
                    <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.GENERAL_INFO' | translate }}</h3>
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <input pInputText id="region" class="form-control" formControlName="region" />
                          <label for="region">{{ 'MEMBER_DETAIL.FIELD_PROVINCE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <input pInputText id="ciudad" class="form-control" formControlName="ciudad" />
                          <label for="ciudad">{{ 'MEMBER_DETAIL.FIELD_CITY' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input pInputText id="pais" class="form-control" formControlName="pais" />
                          <label for="pais">{{ 'MEMBER_DETAIL.FIELD_COUNTRY' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-8">
                        <p-floatLabel variant="on">
                          <input pInputText id="direccion" class="form-control" formControlName="direccion" />
                          <label for="direccion">{{ 'MEMBER_DETAIL.FIELD_ADDRESS' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <p-select formControlName="tipoDocumento" [options]="tipoDocumentoOptions"
                            class="w-100"></p-select>
                          <label for="tipoDocumento">{{ 'MEMBER_DETAIL.FIELD_DOC_TYPE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input pInputText id="numeroDocumento" class="form-control"
                            formControlName="numeroDocumento" />
                          <label for="numeroDocumento">{{ 'MEMBER_DETAIL.FIELD_DOC_NUMBER' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input pInputText id="nacionalidad" class="form-control" formControlName="nacionalidad" />
                          <label for="nacionalidad">{{ 'MEMBER_DETAIL.FIELD_NATIONALITY' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <p-datepicker formControlName="fechaNacimiento" showIcon iconDisplay="button"
                            class="w-100 member-detail-datepicker"></p-datepicker>
                          <label for="fechaNacimiento">{{ 'MEMBER_DETAIL.FIELD_BIRTH_DATE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input pInputText id="paisNacimiento" class="form-control" formControlName="paisNacimiento" />
                          <label for="paisNacimiento">{{ 'MEMBER_DETAIL.FIELD_BIRTH_COUNTRY' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4" data-tour="member-gender">
                        <p-floatLabel variant="on" [ngClass]="{'field-invalid': isInvalidRequired('genero')}">
                          <p-select formControlName="genero" [options]="generoOptions" class="w-100"></p-select>
                          <label for="genero">{{ 'MEMBER_DETAIL.FIELD_GENDER' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <p-select formControlName="estadoCivil" [options]="estadoCivilOptions"
                            class="w-100"></p-select>
                          <label for="estadoCivil">{{ 'MEMBER_DETAIL.FIELD_MARITAL' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <p-select formControlName="estudios" [options]="nivelesEstudios" class="w-100"></p-select>
                          <label for="estudios">{{ 'MEMBER_DETAIL.FIELD_EDUCATION' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input pInputText id="profesion" class="form-control" formControlName="profesion" />
                          <label for="profesion">{{ 'MEMBER_DETAIL.FIELD_PROFESSION' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-12 col-lg-6 col-xl-6 mb-3">
                  <div class="detail-section">
                    <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.SPOUSE_INFO' | translate }}</h3>
                    <!-- ❓ ¿Está registrado como miembro? -->
                    <div class="mb-3">
                      <label class="form-label d-block">{{ 'MEMBER_DETAIL.SPOUSE_QUESTION' | translate }}</label>
                      <div class="flex flex-wrap gap-4 mb-4">
                        <div class="flex items-center">
                          <p-radiobutton name="conyugeRadioGroup" value="SI" formControlName="tieneConyuge"
                            inputId="conyugeSI" />
                          <label for="conyugeSI" class="ml-2">{{ 'MEMBER_DETAIL.SPOUSE_YES' | translate }}</label>
                        </div>
                        <div class="flex items-center">
                          <p-radiobutton name="conyugeRadioGroup" value="NO" formControlName="tieneConyuge"
                            inputId="conyugeNO" />
                          <label for="conyugeNO" class="ml-2">{{ 'MEMBER_DETAIL.SPOUSE_NO' | translate }}</label>
                        </div>
                      </div>
                    </div>
                    <!-- 🟩 Mostrar input solo cuando hay respuesta -->
                    @if (memberDetailForm.get('tieneConyuge')?.value) {
                    <div class="d-flex flex-column w-100">
                      @if (memberDetailForm.get('tieneConyuge')?.value === 'SI') {
                      <p-autoComplete class="flex-grow-1" inputId="conyugeNombre" [optionLabel]="'nombreCompleto'"
                        [suggestions]="opcionesConyuge" (completeMethod)="buscarMiembros($event)"
                        (onSelect)="seleccionarConyuge($event)" formControlName="conyugeNombre" [forceSelection]="true"
                        [placeholder]="'MEMBER_DETAIL.SPOUSE_SEARCH' | translate">
                        <ng-template let-member pTemplate="item">
                          {{ member.nombreCompleto }}
                        </ng-template>
                        <ng-template let-member pTemplate="selectedItem">
                          {{ member.nombreCompleto }}
                        </ng-template>
                      </p-autoComplete>
                      <div class="row">
                        <div class="col-auto ms-auto">
                          <p-button [label]="'MEMBER_DETAIL.SPOUSE_REMOVE' | translate" icon="pi pi-trash" styleClass="p-button-danger mt-3"
                            (click)="removeConyuge()" tooltipPosition="bottom"
                            [pTooltip]="'MEMBER_DETAIL.TOOLTIP_SPOUSE_UNLINK_DETAIL' | translate" size="small" />
                        </div>
                      </div>
                      } @else {
                      <input pInputText class="form-control" [placeholder]="'MEMBER_DETAIL.SPOUSE_NAME_PLACEHOLDER' | translate"
                        formControlName="conyugeNombre" />
                      }
                      @if(selectedConyuge){
                      <div class="mt-3 d-flex gap-2">
                        @if(!tieneConyugeBtn){
                        <p-button [label]="'MEMBER_DETAIL.SPOUSE_LINK' | translate" icon="pi pi-link" severity="info" size="small"
                          (click)="onCreateFamilyWithSpouse()" />
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-6">
                  <div class="detail-section">
                    <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.CHILDREN_INFO' | translate }}</h3>
                    <div class="mb-3">
                      <label class="form-label d-block">{{ 'MEMBER_DETAIL.CHILDREN_QUESTION' | translate }}</label>
                      <div class="flex flex-wrap gap-4 mb-4">
                        <div class="flex items-center">
                          <p-radiobutton name="hijosRadioGroup" [value]="true" formControlName="tieneHijos"
                            name="tieneHijos" inputId="hijosSi" />
                          <label for="hijosSi" class="ml-2">{{ 'MEMBER_DETAIL.SPOUSE_YES' | translate }}</label>
                        </div>
                        <div class="flex items-center">
                          <p-radiobutton name="hijosRadioGroup" [value]="false" formControlName="tieneHijos"
                            name="tieneHijos" inputId="hijosNo" />
                          <label for="hijosNo" class="ml-2">{{ 'MEMBER_DETAIL.SPOUSE_NO' | translate }}</label>
                        </div>
                      </div>
                    </div>
                    @if (memberDetailForm.get('tieneHijos')?.value) {
                    <div [formArrayName]="'hijos'" class="mb-3">
                      @for (hijoControl of hijosControles; track $index) {
                      <div [formGroupName]="$index" class="d-flex align-items-center gap-2 mb-3">
                        <p-floatlabel variant="on" class="flex-grow-1 w-100">
                          <p-autoComplete class="w-100" [formControlName]="'nombre'" [optionLabel]="'nombreCompleto'"
                            [suggestions]="opcionesHijo[$index] || []" [inputId]="'nombrehijo-' + $index"
                            (completeMethod)="buscarMiembrosHijos($event, $index)"
                            (onSelect)="seleccionarHijo($event, $index)" [forceSelection]="false">

                            <ng-template let-hijo pTemplate="item">
                              <div>{{ hijo.nombres }} {{ hijo.apellidos }}</div>
                            </ng-template>

                            <ng-template let-hijo pTemplate="selectedItem">
                              {{ hijo.nombreCompleto }}
                            </ng-template>

                          </p-autoComplete>
                          <label for="nombrehijo">{{ 'MEMBER_DETAIL.CHILDREN_SEARCH' | translate }}</label>
                        </p-floatlabel>
                        <div class="row">
                          <div class="col-auto ms-auto">
                            <p-button icon="pi pi-times" size="small" [rounded]="true" [pTooltip]="'MEMBER_DETAIL.TOOLTIP_REMOVE_ROW' | translate"
                              tooltipPosition="right" severity="danger" [outlined]="true"
                              (click)="eliminarHijo($index)" />
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                    <!-- Botón para añadir otra fila de hijo -->
                    <div class="row justify-content-end mt-2">
                      <div class="col-auto ms-auto">
                        <p-button [label]="'MEMBER_DETAIL.CHILDREN_ADD' | translate" icon="pi pi-plus" size="small" [outlined]="true"
                          severity="success" (click)="addChildRow()"></p-button>
                      </div>
                    </div>
                    @if (hasDisplayedFamily() && (selectedHijos.length) > 0 && hasChildrenToAdd) {
                    <div class="row text-end mt-2">
                      <div class="col-auto ms-auto">
                        <p-button [label]="'MEMBER_DETAIL.CHILDREN_ADD_FAMILY' | translate" icon="pi pi-user-plus" severity="info" size="small"
                          (click)="onAddChildrenToFamily()"
                          [disabled]="!hasDisplayedFamily() || !selectedHijos.length || !hasChildrenToAdd" />
                      </div>
                    </div>
                    }
                    }
                  </div>
                </div>
              </div>
              }
              @case ('espiritual') {
              <div class="row mb-3">
                <div class="col-md-12 col-lg-6 col-xl-6 mb-3">
                  <div class="detail-section">
                    <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.SPIRITUAL_TITLE' | translate }}</h3>
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <p-select formControlName="bautismo" [options]="nivelBautismo" class="w-100"></p-select>
                          <label for="bautismo">{{ 'MEMBER_DETAIL.FIELD_BAPTISM' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <p-datepicker formControlName="fechaBautismo" showIcon iconDisplay="button"
                            class="w-100 member-detail-datepicker" appendTo="body"></p-datepicker>
                          <label for="fechaBautismo">{{ 'MEMBER_DETAIL.FIELD_BAPTISM_DATE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-6 mt-3">
                        <p-floatLabel variant="on">
                          <p-select formControlName="bautismoEspirituSanto" [options]="bautizadoEspirituSanto"
                            class="w-100"></p-select>
                          <label for="bautismoEspirituSanto">{{ 'MEMBER_DETAIL.FIELD_SPIRIT_BAPTISM' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <p-floatlabel variant="on">
                          <textarea pTextarea id="estudiosBiblicos" formControlName="estudiosBiblicos" rows="5"
                            style="resize: none" class="w-100" readonly></textarea>
                          <label for="estudiosBiblicos">{{ 'MEMBER_DETAIL.FIELD_BIBLE_STUDIES' | translate }}</label>
                        </p-floatlabel>
                        <div class="text-end mt-2">
                          <p-button [label]="'MEMBER_DETAIL.BTN_ADD_STUDY' | translate" icon="pi pi-plus" (click)="abrirModalEstudio()"
                            severity="info" size="small" [raised]="true" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-6">
                  <div class="detail-section">
                    <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.CHURCH_TITLE' | translate }}</h3>
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <p-datepicker formControlName="fechaIngreso" showIcon iconDisplay="button"
                            class="w-100 member-detail-datepicker" dateFormat="dd/mm/yy"></p-datepicker>
                          <label for="fechaIngreso">{{ 'MEMBER_DETAIL.FIELD_JOIN_DATE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <p-select formControlName="estadoParticipacion" [options]="estadoParticipacion"
                            class="w-100"></p-select>
                          <label for="estadoParticipacion">{{ 'MEMBER_DETAIL.FIELD_PARTICIPATION' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row mb-4">
                      <div class="col-12">
                        <p-floatLabel variant="on">
                          <input pInputText formControlName="areaServicio" id="areaServicio" class="w-100" />
                          <label for="areaServicio">{{ 'MEMBER_DETAIL.FIELD_SERVICE_AREA' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <p-floatLabel variant="on">
                          <input class="text-center" pInputText id="antiguedad" class="form-control"
                            [(ngModel)]="antiguedadIglesia" [ngModelOptions]="{ standalone: true }" readonly />
                          <label for="antiguedad">{{ 'MEMBER_DETAIL.FIELD_SENIORITY' | translate }}</label>
                        </p-floatLabel>
                      </div>
                      <div class="col-md-6">
                        <p-floatLabel variant="on">
                          <p-select formControlName="tipo" [options]="tipoPersona" class="w-100"></p-select>
                          <label for="tipo">{{ 'MEMBER_DETAIL.FIELD_PERSON_TYPE' | translate }}</label>
                        </p-floatLabel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
              @case ('salud') {
              <div class="detail-section">
                <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.MENU_HEALTH' | translate }}</h3>
                <div class="row mb-4">
                  <div class="col-md-6 col-lg-5 mb-3">
                    <p-floatLabel variant="on">
                      <input pInputText id="alergias" class="form-control" formControlName="alergias" />
                      <label for="alergias">{{ 'MEMBER_DETAIL.FIELD_ALLERGIES' | translate }}</label>
                    </p-floatLabel>
                  </div>
                  <div class="col-md-6 col-lg-5">
                    <p-floatLabel variant="on">
                      <input pInputText id="enfermedades" class="form-control" formControlName="enfermedades" />
                      <label for="enfermedades">{{ 'MEMBER_DETAIL.FIELD_DISEASES' | translate }}</label>
                    </p-floatLabel>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <p-floatLabel variant="on">
                      <p-select formControlName="tipoSangre" [options]="tiposSangre" class="w-100"></p-select>
                      <label for="tipoSangre">{{ 'MEMBER_DETAIL.FIELD_BLOOD_TYPE' | translate }}</label>
                    </p-floatLabel>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p-floatlabel variant="on">
                      <textarea pTextarea id="estadosDeSalud" formControlName="estadosDeSalud" rows="5"
                        style="resize: none" class="w-100" readonly></textarea>
                      <label for="estadosDeSalud">{{ 'MEMBER_DETAIL.FIELD_HEALTH_STATUS' | translate }}</label>
                    </p-floatlabel>
                    <div class="text-end mt-2">
                      <p-button [label]="'MEMBER_DETAIL.BTN_ADD_STATUS' | translate" icon="pi pi-plus" (click)="abrirModalSalud()" severity="info"
                        size="small" [raised]="true" />
                    </div>
                  </div>
                </div>
              </div>
              }
              @case ('pastorales') {
              <div class="detail-section detail-section--notes">
                <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.MENU_PASTORAL' | translate }}</h3>
                <div class="row">
                  <div class="col-md-12">
                    <div class="detail-notes-list">
                      @if (notasFormArray.length > 0) {
                      @for (control of notasFormArray; track $index) {
                      <div class="detail-note-item">
                        <div class="row d-flex align-items-center">
                          <div class="col-md-6 text-start">
                            <small class="text-muted">
                              {{ formatNotaFecha(control.value.fecha) }}
                              @if (control.value.autor) {
                              - {{ control.value.autor }}
                              }
                            </small>
                          </div>
                          <div class="col-md-6 text-end">
                            <p-button icon="pi pi-times" [rounded]="true" [text]="true" severity="danger"
                              [pTooltip]="'MEMBER_DETAIL.TOOLTIP_DELETE' | translate" (click)="eliminarNota($index)" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            {{ control.value.contenido }}
                          </div>
                        </div>
                      </div>
                      }
                      } @else {
                      <p class="text-muted">{{ 'MEMBER_DETAIL.NO_NOTES' | translate }}</p>
                      }
                    </div>
                    <div class="text-end mt-2">
                      <p-button [label]="'MEMBER_DETAIL.BTN_ADD_NOTE' | translate" icon="pi pi-plus" (click)="abrirModalNota()" severity="info"
                        size="small" [raised]="true" />
                    </div>
                  </div>
                </div>
              </div>
              }
              @case ('diezmos') {
              <div class="detail-section detail-section--tithing">
                <h3 class="detail-section__title">{{ 'MEMBER_DETAIL.TITHES_TITLE' | translate }}</h3>

                @if (loadingDiezmos) {
                <div class="text-center py-5">
                  <i class="pi pi-spin pi-spinner text-primary" style="font-size: 2rem"></i>
                  <p class="mt-2 text-muted">{{ 'MEMBER_DETAIL.TITHES_LOADING' | translate }}</p>
                </div>
                } @else {
                @if (diezmoSummaries.length === 0) {
                <div class="detail-alert detail-alert--info" role="alert">
                  <i class="pi pi-info-circle me-2" style="font-size: 1.5rem"></i>
                  <div>
                    {{ 'MEMBER_DETAIL.TITHES_NO_HISTORY' | translate }}
                  </div>
                </div>
                } @else {
                <p-table [value]="diezmoSummaries" [tableStyle]="{ 'min-width': '50rem' }"
                  styleClass="p-datatable-sm p-datatable-striped">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="bg-light">{{ 'MEMBER_DETAIL.TITHES_COL_YEAR' | translate }}</th>
                      <th class="bg-light text-center">{{ 'MEMBER_DETAIL.TITHES_COL_TOTAL' | translate }}</th>
                      <th class="bg-light text-center">{{ 'MEMBER_DETAIL.TITHES_COL_COUNT' | translate }}</th>
                      <th class="bg-light text-center">{{ 'MEMBER_DETAIL.TITHES_COL_LAST_UPDATE' | translate }}</th>
                      <th class="bg-light text-center">{{ 'MEMBER_DETAIL.TITHES_COL_ACTIONS' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-summary>
                    <tr>
                      <td class="fw-bold">{{ summary.year }}</td>
                      <td class="text-center font-monospace">{{ summary.total | missionMoney }}</td>
                      <td class="text-center">{{ summary.count }}</td>
                      <td class="text-center text-muted text-sm">
                        {{ (summary.lastUpdated || summary.lastUpdate)?.toDate
                          ? ((summary.lastUpdated || summary.lastUpdate).toDate() | date:'dd/MM/yyyy')
                          : ((summary.lastUpdated || summary.lastUpdate) | date:'dd/MM/yyyy') }}
                      </td>
                      <td class="text-center">
                        <div class="d-flex gap-2 justify-content-center">
                          <p-button [icon]="selectedYearDiezmos === summary.year ? 'pi pi-eye-slash' : 'pi pi-eye'"
                          [label]="selectedYearDiezmos === summary.year ? ('MEMBER_DETAIL.TITHES_BTN_HIDE' | translate) : ('MEMBER_DETAIL.TITHES_BTN_DETAIL' | translate)" [outlined]="true"
                            size="small" (click)="verDetalleDiezmos(summary.year)"
                            [severity]="selectedYearDiezmos === summary.year ? 'secondary' : 'info'">
                          </p-button>

                          <p-button icon="pi pi-file-pdf" [label]="'MEMBER_DETAIL.TITHES_BTN_CERT' | translate" severity="danger" size="small"
                            (click)="generarCertificado(summary)"
                            [pTooltip]="'MEMBER_DETAIL.TITHES_CERT_PDF_TOOLTIP' | translate">
                          </p-button>
                        </div>
                      </td>
                    </tr>
                    <!-- Detalle Expandido -->
                    @if (selectedYearDiezmos === summary.year) {
                    <tr>
                      <td colspan="5" class="p-0 border-0 bg-white">
                        <div class="p-3 bg-light-subtle inner-table-container">
                          <h6 class="text-secondary ps-2 mb-3 border-start border-1 border-info p-2 rounded-4">
                            {{ 'MEMBER_DETAIL.TITHES_DETAIL_TITLE' | translate: { year: summary.year } }}
                          </h6>

                          @if(diezmoDetails.length > 0) {
                          <p-table [value]="diezmoDetails" class="p-datatable-sm" [rowHover]="true">
                            <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 15%">{{ 'MEMBER_DETAIL.TITHES_COL_DATE' | translate }}</th>
                      <th style="width: 20%" class="text-end">{{ 'MEMBER_DETAIL.TITHES_COL_AMOUNT' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-detalle>
                    <tr>
                      <td>{{ detalle.fecha | date:'dd/MM/yyyy' }}</td>
                      <td class="text-end fw-bold">{{ detalle.monto | missionMoney }}</td>
                    </tr>
                  </ng-template>
                </p-table>
                } @else {
                <div class="text-center py-3 text-muted">
                  <small>{{ 'MEMBER_DETAIL.TITHES_DETAIL_LOADING' | translate }}</small>
                </div>
                }
              </div>
              </td>
              </tr>
              }
              </ng-template>
              </p-table>
              }
              }
            </div>
            }
            }
          </div>
        </div>

      </div>
    </div>
  </div>
</form>
<p-dialog [header]="'MEMBER_DETAIL.DIALOG_STUDY_TITLE' | translate" [(visible)]="mostrarModalEstudio" [modal]="true" [closable]="true"
  [style]="{width: '30vw'}">
  <div class="p-fluid">
    <p-floatLabel variant="on">
      <input pInputText id="nuevoEstudio" [(ngModel)]="nuevoEstudioTexto" [ngModelOptions]="{standalone: true}" />
      <label for="nuevoEstudio">{{ 'MEMBER_DETAIL.DIALOG_STUDY_FIELD' | translate }}</label>
    </p-floatLabel>

    <div class="mt-3 text-end">
      <p-button [label]="'MEMBER_DETAIL.BTN_ADD' | translate" icon="pi pi-check" (click)="agregarEstudioBiblico()" severity="success" size="small" />
    </div>
  </div>
</p-dialog>
<p-dialog [header]="'MEMBER_DETAIL.DIALOG_HEALTH_TITLE' | translate" [(visible)]="mostrarModalSalud" [modal]="true" [closable]="true"
  [style]="{width: '30vw'}">
  <div class="p-fluid">
    <div class="row mt-2">
      <div class="col-12">
        <p-floatLabel variant="on">
          <input pInputText id="estadoSalud" class="w-100" [(ngModel)]="nuevoEstadoSalud"
            [ngModelOptions]="{standalone: true}" />
          <label for="estadoSalud">{{ 'MEMBER_DETAIL.DIALOG_HEALTH_FIELD' | translate }}</label>
        </p-floatLabel>
      </div>
    </div>
    <div class="mt-3 text-end">
      <p-button [label]="'MEMBER_DETAIL.BTN_ADD' | translate" icon="pi pi-check" (click)="agregarEstadoSalud()" severity="info" size="small" />
    </div>
  </div>
</p-dialog>
<p-dialog [header]="'MEMBER_DETAIL.DIALOG_NOTE_TITLE' | translate" [(visible)]="mostrarModalNota" [modal]="true" [style]="{width: '30vw'}">
  <div class="p-fluid">
    <div class="row mt-2">
      <div class="col-12">
        <p-floatLabel variant="on">
          <textarea rows="5" pTextarea id="nuevaNota" class="w-100" [(ngModel)]="nuevoContenidoNota"
            [ngModelOptions]="{standalone: true}" style="resize: none"></textarea>
          <label for="nuevaNota">{{ 'MEMBER_DETAIL.DIALOG_NOTE_FIELD' | translate }}</label>
        </p-floatLabel>
      </div>
    </div>
    <div class="mt-3 text-end">
      <p-button [label]="'MEMBER_DETAIL.BTN_ADD' | translate" icon="pi pi-check" (click)="agregarNota()" severity="success" size="small" />
    </div>
  </div>
</p-dialog>
<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>

<p-dialog [(visible)]="historialDialogVisible" [modal]="true" [draggable]="false" [dismissableMask]="true"
  [style]="{ width: '560px' }" [focusOnShow]="false" styleClass="historial-dialog" (onHide)="closeHistorial()">
  <ng-template pTemplate="header">
    <div class="historial-header">
      <span class="historial-header-icon"><i class="pi pi-history"></i></span>
      <div class="historial-header-text">
        <span class="historial-header-title">{{ 'MEMBER_DETAIL.HISTORY_DIALOG_TITLE' | translate }}</span>
        @if (miembro?.nombres) {
        <span class="historial-header-subtitle">{{ miembro?.nombres }} {{ miembro?.apellidos }}</span>
        }
      </div>
    </div>
  </ng-template>

  <div class="historial-meta">
    <div class="historial-meta-item">
      <span class="historial-meta-label">{{ 'MEMBER_DETAIL.HISTORY_CREATED_BY' | translate }}</span>
      <span class="historial-meta-value">{{ historialCreatedByName }}</span>
    </div>
    <div class="historial-meta-item">
      <span class="historial-meta-label">{{ 'MEMBER_DETAIL.HISTORY_UPDATED_BY' | translate }}</span>
      <span class="historial-meta-value">{{ historialUpdatedByName }}</span>
    </div>
  </div>

  @if (historialEntries.length > 0) {
  <ul class="historial-timeline">
    @for (entry of visibleHistorialEntries; track $index) {
    <li class="historial-item" [ngClass]="entry.action === 'create' ? 'is-create' : 'is-update'">
      <span class="historial-dot">
        <i class="pi" [ngClass]="entry.action === 'create' ? 'pi-plus' : 'pi-pencil'"></i>
      </span>
      <div class="historial-content">
        <div class="historial-content-top">
          <span class="historial-action">
            {{ (entry.action === 'create' ? 'MEMBER_DETAIL.HISTORY_ACTION_CREATE' : 'MEMBER_DETAIL.HISTORY_ACTION_UPDATE') | translate }}
          </span>
          <span class="historial-date">{{ entry.fecha }}</span>
        </div>
        <div class="historial-author">
          <i class="pi pi-user"></i> {{ entry.byName }}
        </div>
        @if (entry.resumen) {
        <div class="historial-resumen">{{ entry.resumen }}</div>
        } @else if (entry.campos?.length) {
        <div class="historial-campos">
          @for (campo of entry.campos; track campo) {
          <span class="historial-chip">{{ campo }}</span>
          }
        </div>
        }
      </div>
    </li>
    }
  </ul>
  @if (hasMoreHistorialEntries) {
  <div class="historial-load-more">
    <span class="historial-showing text-muted small">
      {{ 'COMMON.HISTORY_SHOWING' | translate:{ visible: historialVisibleCount, total: historialEntries.length } }}
    </span>
    <p-button [label]="'COMMON.HISTORY_LOAD_MORE' | translate" icon="pi pi-chevron-down"
      severity="secondary" styleClass="p-button-text p-button-sm" (onClick)="loadMoreHistorial()"></p-button>
  </div>
  }
  } @else {
  <div class="historial-empty">
    <i class="pi pi-inbox"></i>
    <span>{{ 'MEMBER_DETAIL.HISTORY_EMPTY' | translate }}</span>
  </div>
  }

  <ng-template pTemplate="footer">
    <p-button [label]="'COMMON.CLOSE' | translate" icon="pi pi-times" severity="secondary"
      styleClass="p-button-text" (onClick)="closeHistorial()"></p-button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>